import React, { useState } from 'react';
import { getToken, getCurrentUser } from '../lib/localAuth';

function DebugAuthPage() {
  const [debugInfo, setDebugInfo] = useState<any>({});
  const [loading, setLoading] = useState(false);

  const runDebugChecks = async () => {
    setLoading(true);
    const info: any = {};

    try {
      // Check 1: Environment variables
      info.envVars = { localAuth: true };

      // Check 2: Current user
      try {
        const user = await getCurrentUser();
        info.currentUser = user || 'No user logged in';
      } catch (e) {
        info.currentUser = `Error: ${e}`;
      }

      // Check 3: Try to get current session
      const token = getToken();
      info.session = token ? { tokenPreview: token.slice(0, 12) + '...' } : 'No token';

      // Check 4: Test a simple API call
      info.apiTest = 'not-applicable (local auth)';

      // Check 5: Cookie information
      info.cookies = {
        all: document.cookie.split(';').map(c => c.trim().split('=')[0]),
        stackRelated: document.cookie.split(';')
          .filter(c => c.toLowerCase().includes('stack'))
          .map(c => c.trim().split('=')[0]),
      };

      // Check 6: Try manual sign in
      info.signInTest = 'not-applicable (local auth)';

      // Check 7: Stack client configuration
      info.stackConfig = { localAuth: true };

    } catch (error) {
      info.error = String(error);
    }

    setDebugInfo(info);
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-2xl font-bold mb-6">Auth Debug Page</h1>
        
        <button
          onClick={runDebugChecks}
          disabled={loading}
          className="mb-6 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50"
        >
          {loading ? 'Running checks...' : 'Run Debug Checks'}
        </button>

        {Object.keys(debugInfo).length > 0 && (
          <div className="bg-white p-6 rounded-lg shadow">
            <pre className="whitespace-pre-wrap font-mono text-sm">
              {JSON.stringify(debugInfo, null, 2)}
            </pre>
          </div>
        )}

        <div className="mt-8 p-4 bg-yellow-50 border border-yellow-200 rounded">
          <p className="text-sm text-gray-700">
            This debug page reports local auth state (JWT present, current user) for troubleshooting.
          </p>
        </div>
      </div>
    </div>
  );
}

export default DebugAuthPage;
